<template>
    <div class="row center-block">
        <div class="col-md-12">
            <div class="box box-info animated zoomIn" style="animation-duration: 0.5s;">
                <div class="box-header">
                    <slot name="icon"></slot><h3 class="box-title">{{title}}</h3>
                </div>
                <div class="box-body">
                    <slot name="body">
                    </slot>    

                </div>
                <div class="box-footer">
                    <slot name="footer">
                    </slot>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
  name: 'Box',
  props: ['title']
}
</script>
<style>
.box {
    box-shadow: 0 4px 4px rgba(0,0,0,0.2);
}
.box-header {
    display: flex;
}
</style>



// WEBPACK FOOTER //
// Box.vue?b93b8b74